/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Practice_OwnInputs */



/**
* | output |
* | --- |
* | "I want to make my own practice conversation" |
*
* @param {Chat_Quick_Practice_OwnInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_practice_own = /** @type {((inputs?: Chat_Quick_Practice_OwnInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Practice_OwnInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Ik wil mijn eigen oefengesprek maken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Je veux créer ma propre conversation d'entraînement")
	return /** @type {LocalizedString} */ ("I want to make my own practice conversation")
});